import React from 'react';

import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import FormUtils from '../../../../Components/UI/Form/FormUtils';
import ReduxForm from     '../../../../Components/UI/Form/ReduxForm';
import DatePicker from '../../../../Components/UI/DatePicker/DatePicker';
import keyValueStore from '../../lib/keyValueStore';
import { formActions } from '../../../../Components/UI/Form/store/forms-reducer';
import { ageInMonth, randomKey } from "../../../../lib/helper";

// const formU7 = `##Fragebogen U7

// Mein Kind ...

// [x] ...kann über längere Zeit frei und sicher gehen.
// [x] ...geht 3 Stufen im Kinderschritt hinunter, hält sich dabei mit einer Hand fest.
// [x] ...kann Spiralen malen.
// [x] ...kann eingewickelte Bonbons oder andere kleine Gegenstände einwickeln oder auspacken.
// [x] ...kann mindestens 10 Wörter (ohne Mama und Papa) sprechen.
// [x] ...versteht und befolgt einfache Aufforderungen.
// [x] ...drückt durch Gestik (Kopfschütteln) oder Sprache (Nein-Sagen) aus, dass es etwas ablehnt oder eigene Vorstellungen hat.
// [x] ...kann auf 3 benannte Körperteile zeigen oder schauen.
// [x] ...kann 3 Würfel stapeln.
// [x] ...kann im Bilderbuch auf bekannte Gegenstände zeigen.
// [x] ...bleibt und spielt etwa 15 Minuten alleine, wenn ich nicht im Zimmer, aber in der Nähe bin.
// [x] ...kann selbst mit dem Löffel essen.
// [x] ...hat Interesse an anderen Kindern.
// [x] ...versucht, mich irgendwo hinzuziehen.
// `

// const formU7a = `##Fragebogen U7a

// Mein Kind ...

// [x] ...kann von der untersten Treppenstufe hüpfen und dabei das Gleichgewicht halten. 
// [x] ...kann 2 Treppenstufen im Erwachsenenschritt steigen, hält sich dabei mit einer Hand fest.
// [x] ...kann mit drei spitzen Fingern (Daumen, Zeige- und Mittelfinger) auch sehr kleine Gegenstände aufheben.
// [x] ...spricht mindestens Dreiwortsätze. 
// [x] ...spricht von sich in der Ich-Form.
// [x] ...kennt und sagt seinen Rufnamen.
// [x] ...kann zuhören und konzentriert spielen.
// [x] ...kann große Knöpfe selbst öffnen.
// [x] ...kann sich gut über einige Stunden trennen, wenn es von einer vertrauten Person betreut wird.
// [x] ...beteiligt sich an häuslichen Tätigkeiten, will im Haushalt mithelfen.
// [x] ...spielt gemeinsam mit gleichaltrigen Kindern, auch Rollenspiele

//   `
const DataForm = ({ onValidChange, ...props }) => {
  const configData = useSelector(state => state.config.data);
  const birthDate = keyValueStore.search( 'birthdate' );

  const [formId, setFormId] = useState(null);
  const [aim, setAim] = useState( null );
  const [formKey, setFormKey] = useState( randomKey() );
  const [dateValid, setDateValid] = useState(false);

  const store = useSelector( state => state );
  const formState = useSelector( state => state.forms.forms['U'] );
  const dispatch = useDispatch();

  const onBirthdaySet = (date) => {
    const isBeforeToday = date < new Date();
    setDateValid(isBeforeToday);
    if (!isBeforeToday) return;

    const age = ageInMonth( date );
    setAim( age );

    keyValueStore.insert( 'birthdate', date.toJSON() );
    keyValueStore.insert( 'aim', age );

    if ( formId != null ) {
      dispatch( formActions.deleteForm( { label: 'U' } ));
      setFormKey( randomKey() );
    }

    //@TODO: more flexible
    if ( 18 <= age && age <= 27 ){
      keyValueStore.insert( 'formId', "U7" );
      setFormId( "U7" );
    } else {
      if ( 31 <= age && age <= 39 ){
        keyValueStore.insert( 'formId', "U7a" );
        setFormId( "U7a" );
      } else {
        keyValueStore.insert( 'formId', "-" );        
        setFormId( "-" );
      }
    }
  } // onBirthdaySet

  useEffect( () => {
    if (birthDate) onBirthdaySet( new Date( birthDate ))
  }, [birthDate] );

  useEffect(() => {
    if (!dateValid) { onValidChange(false); return; }
    if (formId === null) { onValidChange(false); return; }
    if (formId === '-') { onValidChange(true); return; }
    if (!formState) { onValidChange(false); return; }
    const allAnswered = Object.keys(formState.state)
      .filter(key => formState.entries[key]?.validation)
      .every(key => formState.state[key].valid);
    onValidChange(allAnswered);
  }, [dateValid, formId, formState]);

  let theForm = null;
  formId === "-"   && (theForm = FormUtils.simpleFormConverter(configData.forms[0].content));
  formId === "U7"  && (theForm = FormUtils.simpleFormConverter(configData.forms[1].content));
  formId === "U7a" && (theForm = FormUtils.simpleFormConverter(configData.forms[2].content));
  
  return <>
    <h3>Geburtsdatum</h3>
    <p>
    Bitte geben Sie das Geburtsdatum des Kindes an.<br />
    </p>
    <DatePicker
          onChange={onBirthdaySet}
          startDate={birthDate ? new Date(birthDate) : null}
    />
    {
      (aim !== null) && <p>Alter in Monaten: {aim}</p>
    }
    {
      theForm !== null
      &&  <ReduxForm
            key = {formKey}
            entries = {theForm}
            label = 'U'
          />
  }
  </>
};

export default DataForm;

/*
@Todo:

formConfig = {
  ranges = 
  [
    {
      from: ...,
      to: ...,
      form
    }
  ],
  aim = "Age in Months",
  noFurther = "keine weiteren Fragen"

}
*/